import Matrix from "./matrix";
import React from "react";


export const pin_state = {
    NOT_SELECTABLE: 0,
    AVAILABLE: 1,
    SELECTED: 2,
    IN_USE: 3,
    GPIO_INPUT: 4,
    GPIO_OUTPUT: 5,
    FIXED: 6,
    DISABLED: 7,
    PULL_UP_RESET: -1
};

export class Peripheral extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            pinMap: this.props.pinMap
        };
    }
    render(){
        let peripheral = this.props.peripheral;

        let mat = new Array(peripheral.numPins);
        for (let row = 0; row < peripheral.numPins; row++) {
            // create array to visualize pins
            mat[row] = new Array(this.props.pinMap.length);
            mat[row].fill(0);
            let availablePins = peripheral.pinLocation[row];

            availablePins.forEach((pin) => {
                // check if pin is available on current board
                let col = this.props.pinMap.findIndex((p) => {
                    return (pin === p);
                });
                if (col !== -1) {
                    let currentPinStatus = this.props.pinStatus[pin];
                    if ((currentPinStatus != null)) {
                        if ((currentPinStatus.periName === peripheral.name) &&
                                (peripheral.name === 'gpio') &&
                                (currentPinStatus.pos === row)){
                            mat[row][col] = peripheral.pinIO[pin] === 1 ? pin_state.GPIO_INPUT : pin_state.GPIO_OUTPUT;
                        } else if ((currentPinStatus.periName === peripheral.name) && (currentPinStatus.pos === row)) {
                            mat[row][col] = pin_state.SELECTED;
                             if (peripheral.required[row]){
                                 mat[row][col] = pin_state.FIXED;
                             }
                        } else {
                            mat[row][col] = pin_state.IN_USE;
                        }
                    } else {
                        // Clear User Selected Names when unselecting pin
                        if (peripheral.name === "gpio") {
                            peripheral.userPinNames[pin] = "";
                        } else if (["ksi", "kso"].includes(peripheral.name)) {
                            peripheral.rowCol[row] = -1;
                        }
                        mat[row][col] = pin_state.AVAILABLE;
                    }

                }
            });

            if (this.props.TMCActive || this.props.force_TMC) {
                mat[row][0] = pin_state.DISABLED;
                mat[row][1] = pin_state.DISABLED;
                mat[row][2] = pin_state.DISABLED;
            }

        }
        return (
        <div>
            <Matrix
                key={peripheral.name+"-matrix"}
                selectedBoard={this.props.selectedBoard}
                title={peripheral.name}
                type={peripheral.name}
                pinNames={peripheral.pinNames}
                pinMap={this.props.pinMap}
                columns={mat}
                clickedPinCallback={this.props.clickedPinCallback}/>
        </div>
        );
    }
}
export class PinMap extends React.Component{
    render(){
        let pins = this.props.pins;
        let p = [pins];

        let basePullup = this.props.pullUps;

        /* this occurs because the pin array doesnt map 1-to-1 with the actual array*/
        let ptemp = this.props.pins.map( (value) =>{
           return basePullup[value];
        });

        let pull = [ptemp];
        if (this.props.TMCActive || this.props.force_TMC) {
            console.log("Disabling pullups 0,1,2");
            pull[0][0] = pin_state.DISABLED;
            pull[0][1] = pin_state.DISABLED;
            pull[0][2] = pin_state.DISABLED;
        }
        let st={
            position:'sticky',
            top:'0',
            borderBottom: '1px solid gray',
            zIndex:'5',
            background:'#FbFbFb'
        };
        return (
            <div style={st}>
                <Matrix title="Pins"
                        name='pinMap'
                        type="pinMap"
                        pinStatus={this.props.pinStatus}
                        pinMap={this.props.pinMap}

                        pinNames={['']}
                        columns={p}/>
                <Matrix title="Pullup"
                        name='pinMap'
                        type="pullup"
                        pinStatus={this.props.pinStatus}
                        pinMap={this.props.pinMap}

                        pinNames={['']}
                        clickedPinCallback={this.props.clickedPullupCallback}
                        columns={pull}/>
            </div>
        );
    }
}
